import { render, staticRenderFns } from "./OrderSendMessage.vue?vue&type=template&id=f8205ac0&scoped=true"
import script from "./OrderSendMessage.vue?vue&type=script&lang=js"
export * from "./OrderSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8205ac0",
  null
  
)

export default component.exports